import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';

import { Utilities, DateRange } from '../../utilities/utilities';
//import { CalendarModalOptions, CalendarModal, CalendarResult } from '../ion2-calendar';

import { RangeGroupSelectorComponent } from './range-group-selector/range-group-selector.component';
import { DateRangeSelectorComponent } from './date-range-selector/date-range-selector.component';
export interface SMPickerRange extends DateRange {
  groupBy: string;
}
@Component({
  selector: 'salonmonster-date-picker',
  templateUrl: './smr-date-picker.component.html',
  styleUrls: ['./smr-date-picker.component.scss'],
})
export class SalonMonsterDatePickerComponent implements OnInit {

  @Input() startDate: Date;

  @Input() endDate: Date;

  @Input () requestingReport: string;

  @Input() disabled: boolean;

  @Input() hideGroupBy: boolean;

  @Input() groupByOptions = [
    {label: 'Daily', value: 'daily'},
    {label: 'Weekly', value: 'weekly'},
    {label: 'Monthly', value: 'monthly'}
  ];

  @Input() groupBy: string;

  @Output() rangeChanged = new EventEmitter<SMPickerRange>();

  public title: string;

  constructor (private modalCtrl: ModalController,
    private popoverController: PopoverController) {
      if (!this.startDate) {
        let dateFromCache: string = localStorage.getItem('datePickerStartDate');
  
        if (dateFromCache && Utilities.parseDate(dateFromCache)) {
          this.startDate = Utilities.parseDate(dateFromCache);
        }
      }
  
      if (!this.endDate) {
        let dateFromCache: string = localStorage.getItem('datePickerEndDate');
  
        if (dateFromCache && Utilities.parseDate(dateFromCache)) {
          this.endDate = Utilities.parseDate(dateFromCache);
        }
      }
      if (!this.groupBy) {
        let dateFromCache: string = localStorage.getItem('groupBy');
  
        if (dateFromCache) {
          this.groupBy = dateFromCache;
        } else {
          this.groupBy = 'daily';
        }
      }
  
      this.updateTitle(false);
  }

  public ngOnInit () {


  }

  public updateTitle (emitChange:boolean = true) {
    const daysDiff: number = Utilities.daysDiff(this.startDate, this.endDate);
    const today: Date = new Date();

    if (daysDiff === 0) {

      if (this.areDatesEqual(this.startDate, new Date())) {
        this.title = 'Today';
      } else if (this.areDatesEqual(Utilities.subtractDays(new Date(), 1), this.startDate)) {
        this.title = 'Yesterday';
      } else {
        this.title = Utilities.formatDate(this.startDate, 'MMM D YYYY');
      }

    } else {

      if (Utilities.isBefore(this.endDate, today)) {

        // last week, last month, last year
        let weekRange: DateRange = Utilities.getLastWeekRange();
        let monthRange: DateRange = Utilities.getLastMonthRange();
        let yearRange: DateRange = Utilities.getLastYearRange();
        if (this.areDatesEqual(weekRange.start, this.startDate) && this.areDatesEqual(weekRange.end, this.endDate)) {
          this.title = 'Last Week';
        } else if (this.areDatesEqual(monthRange.start, this.startDate) && this.areDatesEqual(monthRange.end, this.endDate)) {
          this.title = 'Last Month';
        } else if (this.areDatesEqual(yearRange.start, this.startDate) && this.areDatesEqual(yearRange.end, this.endDate)) {
          this.title = 'Last Year';
        } else {
          this.title = `${Utilities.formatDate(this.startDate, 'MMM D YYYY')} - ${Utilities.formatDate(this.endDate, 'MMM D YYYY')}`;
        }

      } else {

        // this week, this month, this year
        let weekRange: DateRange = Utilities.getThisWeekRange();
        let monthRange: DateRange = Utilities.getThisMonthRange();
        let yearRange: DateRange = Utilities.getThisYearRange();

        if (this.areDatesEqual(weekRange.start, this.startDate) && this.areDatesEqual(weekRange.end, this.endDate)) {
          this.title = 'This Week';
        } else if (this.areDatesEqual(monthRange.start, this.startDate) && this.areDatesEqual(monthRange.end, this.endDate)) {
          this.title = 'This Month';
        } else if (this.areDatesEqual(yearRange.start, this.startDate) && this.areDatesEqual(yearRange.end, this.endDate)) {
          this.title = 'This Year';
        } else {
          this.title = `${Utilities.formatDate(this.startDate, 'MMM D YYYY')} - ${Utilities.formatDate(this.endDate, 'MMM D YYYY')}`;
        }

      }

    }

    if (emitChange) {
      localStorage.setItem('datePickerStartDate', Utilities.formatDate(this.startDate));
      localStorage.setItem('datePickerEndDate', Utilities.formatDate(this.endDate));
      if((this.groupBy === 'daily') || (this.groupBy === 'weekly') || (this.groupBy === 'monthly')) {
        localStorage.setItem('groupBy', this.groupBy);
      }
      this.rangeChanged.emit({start: this.startDate, end: this.endDate, groupBy: this.groupBy});
    }
  }

  public async changeDate () {
    const modal = await this.modalCtrl.create({
      component: DateRangeSelectorComponent, 
      componentProps:{
      start: this.startDate,
      end: this.endDate
    }
  });
    modal.onWillDismiss().then((dateRange: any) => {
      if (dateRange.data) {
        this.startDate = dateRange.data.start;
        this.endDate = dateRange.data.end;
        this.updateTitle();
      }
    });
    modal.present();
  }

  public onGroupByChange (value: string) {
    this.groupBy = value;
    this.updateTitle();
  }

  public async changeRangeGrouping ($event) {
    const popOver = await this.popoverController.create({
      component: RangeGroupSelectorComponent, 
      componentProps:{ groupByOptions: this.groupByOptions
     },
     backdropDismiss: true,
     event:$event
     
    });

    popOver.onDidDismiss().then((value:any) => {
      if (value.data) {
        this.onGroupByChange(value.data);
      }
    });
    popOver.present();
  }

  public previous ($event) {
    $event.stopPropagation();
    const daysDiff: number = Utilities.daysDiff(this.startDate, this.endDate) + 1;
    this.startDate = Utilities.subtractDays(this.startDate, daysDiff);
    this.endDate = Utilities.subtractDays(this.endDate, daysDiff);
    this.updateTitle();
  }

  public next () {
    const daysDiff: number = Utilities.daysDiff(this.startDate, this.endDate) + 1;
    this.startDate = Utilities.addDays(this.startDate, daysDiff);
    this.endDate = Utilities.addDays(this.endDate, daysDiff);
    this.updateTitle();
  }

  public areDatesEqual (date1: Date, date2: Date) : boolean {
    return Utilities.formatDate(date1, 'MMM D YYYY') === Utilities.formatDate(date2, 'MMM D YYYY');
  }

}
